import { render, staticRenderFns } from "./group-list-card.vue?vue&type=template&id=59e07bfb"
import script from "./group-list-card.vue?vue&type=script&lang=js"
export * from "./group-list-card.vue?vue&type=script&lang=js"
import style0 from "./group-list-card.vue?vue&type=style&index=0&id=59e07bfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports